const PREF_KEY = 'preferred_dashboard';
const BETA_VISITS_KEY = 'beta_consecutive_visits';
const CLASSIC_VISITS_KEY = 'classic_consecutive_visits';
const THRESHOLD = 3;

export function getPreferredDashboard() {
  return localStorage.getItem(PREF_KEY) || 'classic';
}

export function setPreferredDashboard(value) {
  localStorage.setItem(PREF_KEY, value);
}

export function recordVisit(dashboard) {
  if (dashboard === 'beta') {
    const visits = parseInt(localStorage.getItem(BETA_VISITS_KEY) || '0', 10) + 1;
    localStorage.setItem(BETA_VISITS_KEY, String(visits));
    localStorage.setItem(CLASSIC_VISITS_KEY, '0');
    if (visits >= THRESHOLD) setPreferredDashboard('beta');
  } else {
    const visits = parseInt(localStorage.getItem(CLASSIC_VISITS_KEY) || '0', 10) + 1;
    localStorage.setItem(CLASSIC_VISITS_KEY, String(visits));
    localStorage.setItem(BETA_VISITS_KEY, '0');
    if (visits >= THRESHOLD) setPreferredDashboard('classic');
  }
}
